import React from "react";
import styled from "styled-components/macro";

const colours = {
  purple: "var(--juno-color-purple)",
  white: "var(--juno-color-white)",
};

const StyledCircle = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;

  font-size: 14px;
  font-weight: var(--juno-font-weight-bold);

  width: 32px;
  height: 32px;
  border-radius: 50%;
  padding-top: 2px;

  border: 2px solid ${({ $background }) => colours[$background]};
  background-color: ${({ $background }) => colours[$background]};
  color: ${({ $colour }) => colours[$colour]};
`;

function Circle({ background, color, dataTestId, className, title, children }) {
  return (
    <StyledCircle $background={background} $colour={color} data-testid={dataTestId} className={className} title={title}>
      {children}
    </StyledCircle>
  );
}

export default Circle;
